import { useSettings } from '../../../Settings/SettingsProvider';
import { useSession } from '@ais-ui/websockets';
import { useFilterContext } from '../../FilterContext';
import { useToast } from '@ais-ui/ui-core';
import { useEffect, useRef } from 'react';
import { loadFavoriteFilters } from '../LayersOnStart/layerLoadingUtils';

export const useFavoriteFilterData = () => {
  const { settings } = useSettings();

  const favoriteFilters =
    settings['ribbonPlugin.settings']?.favorite_filters?.filters || [];

  return {
    favoriteFilters,
  };
};

export const useLoadFiltersOnStart = () => {
  const { olSession } = useSession();
  const { favoriteFilters } = useFavoriteFilterData(); // Added parentheses to call the hook
  const filterContext = useFilterContext();

  const { toast } = useToast();

  const loadedFiltersOnStart = useRef(false);

  useEffect(() => {
    const loadFilters = async () => {
      if (loadedFiltersOnStart.current) return;
      loadedFiltersOnStart.current = true;
      await loadFavoriteFilters(
        favoriteFilters,
        olSession,
        filterContext,
        toast,
      );
    };

    loadFilters();
  }, [favoriteFilters, olSession, filterContext, toast]);
};
